import Agents from './agents';
import Agent from './agent';

export default Agents;
export { Agent, Agents };
export {
  CHECKER_VID_LABELS,
  createAgent,
  deleteAgent,
  getAgent,
  getAgents,
  getCheckerVidLabel,
  updateAgent,
} from './agents';
